import { Component, Input, OnInit } from '@angular/core';
import { Suffix } from '../pr-input-radio/pr-input-radio.component';

@Component({
    selector: 'pr-suffix',
    templateUrl: './pr-suffix.component.html',
    styleUrls: ['./pr-suffix.component.scss'],
    standalone: false
})
export class PrSuffixComponent implements OnInit {
  @Input() suffix: Suffix = {
    title: '',
    color: '',
    backgroundColor: '',
    borderColor: '',
    default: true,
    className: 'suffix',
  };
  constructor() {}

  ngOnInit() {
    this.suffix = {
      ...this.suffix,
      ...{ className: this.suffix.className || 'suffix' },
    };
  }
}
